import React, { useEffect, useState } from 'react';

interface VacationStatus {
    vacation_mode: boolean;
    vacation_message: string;
    vacation_return_date: string | null;
}

const VacationBanner: React.FC = () => {
    const [vacation, setVacation] = useState<VacationStatus | null>(null);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        fetch('/api/vacation')
            .then(r => r.ok ? r.json() : null)
            .then(data => {
                if (data?.vacation_mode) setVacation(data);
            })
            .catch(() => {});
    }, []);

    if (!vacation?.vacation_mode || dismissed) return null;

    const formatDate = (iso: string) => {
        try {
            return new Date(iso).toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' });
        } catch {
            return iso;
        }
    };

    const message = vacation.vacation_message ||
        'Jesteśmy na urlopie. Zamówienia przyjmujemy, ale wysyłka nastąpi po naszym powrocie.';

    return (
        <div className="w-full bg-gradient-to-r from-orange-500 via-amber-400 to-orange-500 py-5 px-4 relative">
            <style>{`
                @keyframes vacationMarquee {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.85; }
                }
                .vacation-glow {
                    box-shadow: 0 4px 24px rgba(251,146,60,0.5), 0 2px 8px rgba(251,146,60,0.3);
                }
            `}</style>

            <div className="vacation-glow max-w-3xl mx-auto bg-[#0f1117] border-2 border-orange-400/80 rounded-2xl px-6 py-5 flex flex-col items-center text-center gap-3 relative">
                {/* Close button */}
                <button
                    onClick={() => setDismissed(true)}
                    aria-label="Zamknij"
                    className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white/60 hover:text-white transition-all text-sm"
                >
                    ✕
                </button>

                {/* Icon + title */}
                <div className="flex items-center gap-3">
                    <span className="text-4xl">🏖️</span>
                    <h2 className="text-xl sm:text-2xl font-extrabold text-orange-400 tracking-tight">
                        Przerwa urlopowa
                    </h2>
                </div>

                {/* Message */}
                <p className="text-white text-sm sm:text-base leading-relaxed max-w-xl">
                    {message}
                </p>

                {/* Return date */}
                {vacation.vacation_return_date && (
                    <div className="inline-flex items-center gap-2 bg-orange-400/15 border border-orange-400/40 rounded-xl px-4 py-2 mt-1">
                        <span className="text-lg">📅</span>
                        <span className="text-orange-300 font-bold text-sm sm:text-base">
                            Wznowienie wysyłek: <span className="text-white">{formatDate(vacation.vacation_return_date)}</span>
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VacationBanner;

